<template>
  <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.73517" width="22.1234" height="2.37036" rx="1.18518" transform="rotate(43.7056 2.73517 0)" fill="currentColor" />
    <rect width="22.1234" height="2.37036" rx="1.18518" transform="matrix(-0.7229 0.690953 0.690953 0.7229 16.4246 0)" fill="currentColor" />
  </svg>
</template>
